export interface DataEntity_Detail_06_Interface {
    id: number,
    main_id: number,
  
    converage: string,
    sample: string,
    reference_up: string,
    reference_down: string,
    uncertainty: string,
  

    before:boolean,

  }
  
  export function Empty_DataEntity_Detail_06_Interface(): DataEntity_Detail_06_Interface {
    return {
      id: 0,
      main_id: 0,
  
      converage: '',
      sample: '',
      reference_up: '',
      reference_down: '',
      uncertainty: '',
    
      before:false
    }
  }
  